import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/landing/HeroSection';
import ProblemSolutionSection from '../components/landing/ProblemSolutionSection';
import StatsSection from '../components/landing/StatsSection';
import UseCasesSection from '../components/landing/UseCasesSection';
import AutomationSection from '../components/landing/AutomationSection';
import BranchenSection from '../components/landing/BranchenSection';
import BundeslaenderSection from '../components/landing/BundeslaenderSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import ComparisonSection from '../components/landing/ComparisonSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import PricingPreviewSection from '../components/landing/PricingPreviewSection';
import FAQSection from '../components/landing/FAQSection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>Adloc - B2B Firmenadressen Deutschland | Vollständige Kontaktdatenbank</title>
        <meta 
          name="description" 
          content="Deutschlands vollständigste B2B-Kontaktdatenbank. Über 50.000+ geprüfte Unternehmenskontakte. 10 kostenlose Credits. Filtern Sie nach Bundesland, Stadt & Branche." 
        />
        <meta 
          name="keywords" 
          content="B2B Firmenadressen, Firmenadressen Deutschland, B2B Leads Deutschland, Unternehmenskontakte, Geschäftskontakte Deutschland, Firmendatenbank, Business Leads, Kontaktdaten kaufen, B2B Marketing, Lead Generation" 
        />
        <meta property="og:title" content="Adloc - B2B Firmenadressen Deutschland" />
        <meta property="og:description" content="Deutschlands vollständigste B2B-Kontaktdatenbank mit über 50.000+ geprüften Kontakten" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://adloc.io" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://adloc.io" />
        
        {/* Google Analytics - Platzhalter */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=USER_GA4_ID"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'USER_GA4_ID');
          `}
        </script>
        
        {/* Meta Pixel - Platzhalter */}
        <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', 'USER_META_PIXEL_ID');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=USER_META_PIXEL_ID&ev=PageView&noscript=1" />`}
        </noscript>
        
        {/* Schema.org structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Adloc",
            "url": "https://adloc.io",
            "logo": "https://adloc.io/logo.png",
            "description": "Deutschlands vollständigste B2B-Kontaktdatenbank",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Hüttenstraße 100",
              "addressLocality": "Bendorf",
              "postalCode": "56170",
              "addressCountry": "DE"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "email": "kontakt@adloc.io",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>
      
      <div className="min-h-screen bg-[#FAF3E0]">
        <HeroSection />
        <ProblemSolutionSection />
        <StatsSection />
        <UseCasesSection />
        <AutomationSection />
        <BranchenSection />
        <BundeslaenderSection />
        <FeaturesSection />
        <ComparisonSection />
        <HowItWorksSection />
        <PricingPreviewSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;